import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import {
	getProductsByShop,
	changeTabAndGetRequiredData,
	setSearchFilter,
	resetData,
	setIsFirstLoad,
	clearProductsError,
	selectProduct,
	deleteProducts,
	selectAllProducts,
	exportProducts,
	setSortOrder,
} from 'modules/product/products';
import { IProductListItemCard } from 'models/product/productlistitem';
import { Button, ErrorSummary, WhiteButton, SearchInput, ProductsTableHeader, ProductTableRow } from 'components';
import { browserHistory, RouteComponentProps } from 'react-router';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { showModal, closeModal } from 'modules/modal';
import { BasicButton, ButtonRound } from 'components/Common/Button';
import renderIcon from 'helpers/renderIcon';
import { PortalSelectMenu } from 'components/FormControls';
import { IDropdownData } from 'models/common';
import { ProductsSort } from 'models';
import { Dispatch } from 'react-redux';
import { ITranslateProps } from 'models/common';
const InfiniteScroll = require('react-infinite-scroll-component');
const { connect } = require('react-redux');

interface IParams {
	id?: string;
}

interface IProps
	extends RouteComponentProps<IParams, {}>,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {}

const mapStateToProps = (state: IStore) => ({
	productsData: state.products,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	dispatch,
	getProductsByShop: (id: string, publishedOnly: boolean, groupVariants: boolean) =>
		dispatch(getProductsByShop(id, publishedOnly, groupVariants)),
	changeTabAndGetRequiredData: (selectedTab: string, tabNamespace: string, shopId: string) =>
		dispatch(changeTabAndGetRequiredData(selectedTab, tabNamespace, shopId)),
	setSearchFilter: (keyword: string) => dispatch(setSearchFilter(keyword)),
	resetData: () => dispatch(resetData()),
	setIsFirstLoad: (isFirstLoad: boolean) => dispatch(setIsFirstLoad(isFirstLoad)),
	clearProductsError: () => dispatch(clearProductsError()),
	selectProduct: (id: string, select: boolean) => dispatch(selectProduct(id, select)),
	deleteProducts: (shopId: string) => dispatch(deleteProducts(shopId)),
	closeModal: () => dispatch(closeModal()),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	selectAllProducts: (select: boolean) => dispatch(selectAllProducts(select)),
	exportProducts: (shopId: string, filename: string) => dispatch(exportProducts(shopId, filename)),
	setSortOrder: (order: ProductsSort) => dispatch(setSortOrder(order)),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopProductsComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMore = this.loadMore.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.deleteProducts = this.deleteProducts.bind(this);
		this.openDeleteProducts = this.openDeleteProducts.bind(this);
		this.handleExportProductsClick = this.handleExportProductsClick.bind(this);
		this.handleOnSortClick = this.handleOnSortClick.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetData();
		this.props.setIsFirstLoad(true);
		this.props.setSearchFilter('');
	}

	public componentDidMount() {
		this.props.changeTabAndGetRequiredData(c.PRODUCTS_TAB_PRODUCTS, 'productstabs', this.shopId);
	}

	private get shopId() {
		return this.props.params.id;
	}

	private handleOnSortClick(sortOrder: ProductsSort) {
		this.props.setIsFirstLoad(true);
		this.props.setSortOrder(sortOrder);
		this.props.getProductsByShop(this.props.params.id, false, false);
	}

	public loadMore() {
		this.props.getProductsByShop(this.shopId, false, false);
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		this.props.setSearchFilter(value.length > 0 ? value : '');
	}

	private handleSearchEnterPress(event: any) {
		if (event.key === 'Enter') {
			this.props.getProductsByShop(this.shopId, false, false);
		}
	}

	private openDeleteProducts() {
		const dialogContent = (
			<div>
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{this.props.t('BSPortal_Common_ConfirmationDialog_Sure')}</h2>
				<p>{this.props.t('Shop_ManageShop_Products_DeleteProducts')}</p>
				<p>{this.props.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteProducts,
			yesButtonText: this.props.t('BSPortal_Common_YesDelete'),
			noButtonText: this.props.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private handleExportProductsClick() {
		const filename = `Products_${Date.now()}.csv`;
		this.props.exportProducts(this.shopId, filename);
	}

	private deleteProducts(confirm: boolean) {
		if (confirm) {
			this.props.deleteProducts(this.shopId);
		}
		this.props.closeModal();
	}

	private loadTabsContent(): JSX.Element[] {
		const tabsContent: JSX.Element[] = [];
		const { t } = this.props;
		const { keywordFilter, selectedProducts } = this.props.productsData;

		let searchFilter: string = keywordFilter;
		if (!searchFilter) {
			searchFilter = '';
		}

		const { itemsPage, items } = this.props.productsData;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMore,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const sortItems: IDropdownData[] = [];

		for (const n in ProductsSort) {
			if (typeof ProductsSort[n] === 'number') {
				sortItems.push({ key: ProductsSort[n], value: t('ProductsSearchResults_Sort_' + n) });
			}
		}
		const dropDownInputProps: any = {
			id: 'sortdropdown',
			onChange: this.handleOnSortClick,
			value: this.props.productsData.sortOrder,
			name: 'sortdropdown',
		};

		tabsContent.push(
			<React.Fragment key="m">
				<div className="row">
					<div className="col-md-4">
						<PortalSelectMenu
							className="rounded small"
							input={dropDownInputProps}
							items={sortItems}
							isRequired={true}
							label={t('SortRow_SortBy')}
						/>
					</div>
					<div className="col-md-8">
						<div className="search-filter">
							<SearchInput
								keyword={searchFilter}
								onSearchEnterPress={this.handleSearchEnterPress}
								onSearchValueChange={this.handleSearchValueChange}
								placeholder={t('Shop_ManageShop_Products_Label_SearchYourShop')}
							/>
							<ButtonRound type="button">{renderIcon('filter')}</ButtonRound>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<p className="p12 productsCount">
							{items.length} {t('Shop_ManageShop_Products_Count')}
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<InfiniteScroll {...infiniteScrollProps} className="productsTable">
							<ProductsTableHeader
								items={items}
								selectedProducts={selectedProducts}
								columnNames={{
									number: '#',
									category: t('Shop_ManageShop_Products_Label_Categories'),
									title: t('Shop_ManageShop_Products_Label_Title'),
									price: t('Shop_ManageShop_Products_Label_Price'),
									salePrice: t('Shop_ManageShop_Products_Label_SalePrice'),
									quantity: t('Shop_ManageShop_Products_Label_Quantity'),
									sold: t('Shop_ManageShop_Products_Label_Sold'),
									revenue: t('Shop_ManageShop_Products_Label_Revenue'),
									sku: t('Shop_ManageShop_Products_Label_Sku'),
									status: t('Shop_ManageShop_Products_Label_Status'),
								}}
								selectAllProducts={this.props.selectAllProducts}
							/>
							{this.props.productsData.items.map((item: IProductListItemCard, index: number) => {
								const attributes = item.attributes || {};
								return (
									<ProductTableRow
										key={item.id}
										item={item}
										selectedProducts={selectedProducts}
										size={attributes.SizeKey ? t(`DV_Sizes_${attributes.SizeKey}`) : ''}
										selectProduct={this.props.selectProduct}
										productIndex={index + 1}
										edit={t('Shop_ManageShop_Products_Edit')}
									/>
								);
							})}
						</InfiniteScroll>
					</div>
				</div>
			</React.Fragment>,
		);
		return tabsContent;
	}

	public render() {
		const { t } = this.props;
		const { error, message, selectedProducts } = this.props.productsData;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<div className="shopProductsWrapper">
				<div className="buttons">
					<Button
						size="small"
						onClick={() => {
							browserHistory.push(`/shop/${this.shopId}/edit/products/create`);
						}}
					>
						{t('Shop_ManageShop_Products_Button_AddProduct')}
					</Button>
					<WhiteButton
						size="small"
						onClick={() => {
							browserHistory.push(`/shop/${this.shopId}/edit/products/import`);
						}}
					>
						{t('Shop_ManageShop_Products_Button_ImportProduct')}
					</WhiteButton>
					<WhiteButton size="small" onClick={this.handleExportProductsClick}>
						{t('Shop_ManageShop_Products_Button_ExportProduct')}
					</WhiteButton>
					<BasicButton
						size="small"
						onClick={this.openDeleteProducts}
						className={selectedProducts.length === 0 ? 'hide' : 'deleteButton'}
					>
						{renderIcon('delete_2')}
						{t('Shop_ManageShop_Products_Delete_Products')} ({selectedProducts.length})
					</BasicButton>
				</div>
				<div>
					<div className="productsError">
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<div>{this.loadTabsContent()}</div>
				</div>
			</div>
		);
	}
}

const ShopProducts = connect(mapStateToProps, mapDispatchToProps)(ShopProductsComponent);

export { ShopProducts };
